

@if(emojiGroups) {
<div class="dropdownWrap">
	<div class="btn-group" *ngIf="emojiGroups" dropdown [isDisabled]="maxLength && value.length >= maxLength" [insideClick]="true" [dropup]="true">
		<button type="button" dropdownToggle class="btn btn-white dropdown-toggle">
			<span class="glyphicons plus">
			</span>
		</button>

		<div *dropdownMenu class="dropdown dropdown-menu">

			<div class="selectWrap">
				<span>{{ 'Emoji' | translate }}</span>
				<select [(ngModel)]="selectedGroup">
					@for(group of emojiGroups; track $index) {
						<option [ngValue]="group">{{group.name}}</option>
					}
				</select>
			</div>

			<div class="emojiGrid">
				@for(emoji of selectedGroup.emojis; track $index) {
					<button type="button" [tooltip]="emoji.name" (click)="addEmoji(emoji)">
						{{emoji.char}}
					</button>
				}
			</div>
		</div>
	</div>
</div>
}

@for(emoji of value; track $index) {
	<div class="selectedEmoji">
		<span class="me-2">{{emoji.char}}</span>
		<span>{{emoji.name}}</span>
		<button type="button" class="removeBtn" [attr.aria-label]="'Remove' | translate" (click)="removeEmoji($index)">
			<span class="vb-icon vb-icon-close"></span>
		</button>
	</div>
	}
